import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { useEffect } from 'react';
import { ICrudGetProps } from '@monorepo/tools/src/lib/interfaces/crud';
import { useLocation } from 'react-router-dom';
import { IAdminxStore } from '../../stores';

export function useCreativeGet(props: ICrudGetProps) {
	const { id, options } = props;
	const { creativeStore } = useStores<IAdminxStore>();
	const location = useLocation();

	useEffect(() => {
		if (id) {
			creativeStore.getCrud().get(id, options);
		}
	}, [location]);

	if (!id) {
		return null;
	}

	return { error: creativeStore.getCrud().getHttpError(), isLoading: creativeStore.getCrud().getIsLoading() };
}
